import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from "react";
import styled from "styled-components/macro";
import Portal from "../components/Portal";
import {
  BoxContent,
  Box,
  BoxFooter,
  BoxNavLeft,
  BoxNavRight,
} from "../components/Box";
import Button from "../components/Button";
import Stack from "../components/Stack";
import { useHistory } from "react-router";

const context = createContext<null | Dispatch<SetStateAction<string | null>>>(
  null
);

export function PaywallProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState<string | null>(null);
  const history = useHistory();

  return (
    <context.Provider value={setTitle}>
      {children}
      {title && (
        <Portal>
          <Wrapper>
            <Container>
              <Box elevated>
                <BoxContent>
                  <Stack>
                    <HelpParagraph>{title}</HelpParagraph>
                  </Stack>
                </BoxContent>
                <BoxFooter white stacked>
                  <BoxNavLeft>
                    <Button
                      variant="link"
                      onClick={() => {
                        setTitle(null);
                      }}
                    >
                      Cancel
                    </Button>
                  </BoxNavLeft>
                  <BoxNavRight>
                    <Button
                      onClick={() => {
                        history.push("/app/plan");
                        setTitle(null);
                      }}
                    >
                      View Plans
                    </Button>
                  </BoxNavRight>
                </BoxFooter>
              </Box>
            </Container>
          </Wrapper>
        </Portal>
      )}
    </context.Provider>
  );
}

export default function usePaywall() {
  const setTitle = useContext(context)!;

  return function showPaywall(title: string) {
    setTitle(title);
  };
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow: auto;
  z-index: 10000;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0001;
`;

const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 40px;
  width: 60vw;
  max-height: 100%;
  max-width: 600px;
`;

const HelpParagraph = styled.p`
  max-width: 70ch;
  line-height: 1.6em;
  strong {
    font-weight: 500;
  }
`;
